import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axiosJob = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}/early-applicant/`
);

const axiosUser = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/suggest/`
);

const suggestedskills = async () => {
  try {
    const response: any = await axiosUser.get('skills');
    if (response[STATUS] === 200) {
      return response?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const suggestedskillsByFunctional = async (functionalArea: string) => {
  try {
    const response: any = await axiosJob.get('getSkills', {
      params: {
        functionalarea: functionalArea,
        aggname: 'id',
      },
    });

    if (response[STATUS] === 200) {
      return response?.data;
    }

    return {};
  } catch (error: any) {
    return {
      error: {
        message:
          error?.response?.data?.error?.message || 'Something went wrong',
        code: error?.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const suggestionService = {
  suggestedskills,
  suggestedskillsByFunctional,
};

export default suggestionService;
